import { Text, TextInput, TouchableOpacity, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { currency } from '../lib/format';

export const emptySubExpense = () => ({ item: '', amount: '', notes: '' });

export const normalizeSubExpenses = (rows = []) => rows
  .map((row) => ({
    item: String(row.item || '').trim(),
    amount: String(row.amount || ''),
    notes: String(row.notes || '').trim(),
  }))
  .filter((row) => row.item || row.amount);

export const subExpenseTotal = (rows = []) => rows.reduce((sum, row) => sum + Number(row.amount || 0), 0);

export default function SubExpenseEditor({ rows, onChange, title = 'Sub-expenses', subtitle = 'Break this expense into the items that make it up.' }) {
  const updateRow = (index, patch) => {
    onChange(rows.map((row, rowIndex) => (rowIndex === index ? { ...row, ...patch } : row)));
  };

  const removeRow = (index) => {
    onChange(rows.filter((_, rowIndex) => rowIndex !== index));
  };

  return (
    <View className="rounded-2xl border border-slate-200 bg-white p-4">
      <View className="mb-3 flex-row items-start justify-between gap-3">
        <View className="flex-1">
          <Text className="font-black text-slate-950">{title}</Text>
          <Text className="mt-1 text-sm text-slate-500">{subtitle}</Text>
        </View>
        <Text className="font-black text-cyan-700">{currency(subExpenseTotal(rows))}</Text>
      </View>

      {rows.map((row, index) => (
        <View key={index} className="mb-3 rounded-2xl bg-slate-50 p-3">
          <View className="flex-row gap-2">
            <TextInput
              className="flex-1 rounded-xl border border-slate-200 bg-white px-3 py-2 text-slate-950"
              placeholder="Item, e.g. Rice"
              placeholderTextColor="#94a3b8"
              value={row.item}
              onChangeText={(value) => updateRow(index, { item: value })}
            />
            <TextInput
              className="w-28 rounded-xl border border-slate-200 bg-white px-3 py-2 text-slate-950"
              placeholder="Amount"
              placeholderTextColor="#94a3b8"
              keyboardType="decimal-pad"
              value={String(row.amount)}
              onChangeText={(value) => updateRow(index, { amount: value })}
            />
          </View>
          <View className="mt-2 flex-row items-center gap-2">
            <TextInput
              className="flex-1 rounded-xl border border-slate-200 bg-white px-3 py-2 text-slate-950"
              placeholder="Note, optional"
              placeholderTextColor="#94a3b8"
              value={row.notes}
              onChangeText={(value) => updateRow(index, { notes: value })}
            />
            <TouchableOpacity className="h-10 w-10 items-center justify-center rounded-xl bg-rose-50" onPress={() => removeRow(index)}>
              <MaterialIcons name="delete-outline" size={20} color="#e11d48" />
            </TouchableOpacity>
          </View>
        </View>
      ))}

      <TouchableOpacity className="flex-row items-center justify-center rounded-xl border border-cyan-200 bg-cyan-50 px-4 py-3" onPress={() => onChange([...rows, emptySubExpense()])}>
        <MaterialIcons name="add" size={20} color="#0e7490" />
        <Text className="ml-1 font-bold text-cyan-800">Add sub-expense</Text>
      </TouchableOpacity>
    </View>
  );
}
